type Props = {
  total: number | undefined;
  'data-testid'?: string;
};

export function TotalCount({ total, 'data-testid': e2eId }: Props) {
  if (total === undefined) {
    return null;
  }
  return (
    <div className="flex flex-row gap-1 text-sm text-black">
      <span className="text-gray-500">Total</span>
      <span data-testid={e2eId}>{total}</span>
      <span>{total === 1 ? 'result' : 'results'}</span>
    </div>
  );
}
